import { render, staticRenderFns } from "./StatsFunnelRecords.vue?vue&type=template&id=83a28d48&scoped=true&"
import script from "./StatsFunnelRecords.vue?vue&type=script&lang=js&"
export * from "./StatsFunnelRecords.vue?vue&type=script&lang=js&"
import style0 from "./StatsFunnelRecords.vue?vue&type=style&index=0&id=83a28d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a28d48",
  null
  
)

export default component.exports